import React from 'react'
import CanvasComponent from '../components/canvasComponent'

function CreatorPage() {
  return (
	<CanvasComponent/>
  )
}

export default CreatorPage